import { CCUtils } from "../../../../common/CCUtils"
import { log } from "../../../../common/Logging"
import { Align, FontType } from "../../../../common/TextUtils"
import { StudentStoreSA } from "../../../../react/students/StudentStoreSA"
import { PhaserText } from "../../../utils/PhaserText"
import { PhaserUtils } from "../../../utils/PhaserUtils"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { MakeAVideoStore } from "../MakeAVideoStore"
import { MakeVideoLayoutTypes, MakeVideoSprite } from "../MakeVideoTypes"
import { MakeVideoBackgroundImage } from "./MakeVideoBackgroundSelectContainer"

export class MakeVideoLayoutTypeContainer implements MakeVideoSprite {

    private static wordWrapWidth = 0.01
    private static lineSpacing = -10

    active: boolean
    top: Phaser.Text
    middle: Phaser.Text
    bottom: Phaser.Text

    constructor(
        private game: Phaser.Game,
        group: Phaser.Group,
        private background: MakeVideoBackgroundImage,
        private fontPx: number,
        public layout: MakeVideoLayoutTypes
    ) {
        this.middle = this.byline
        if (layout === MakeVideoLayoutTypes.LAYOUT_2) {
            this.top = this.username
            this.bottom = this.title
        } else {
            this.top = this.title
            this.bottom = this.username
        }
        this.formatLayoutText()
        this.active = true
    }

    destroy = () => {
        this.top.destroy(true)
        this.middle.destroy(true)
        this.bottom.destroy(true)
        this.active = false
    }

    private formatLayoutText = () => {
        Sprites.centerTextInSprite(this.background.sprite, this.top)
        this.top.y -= (this.background.sprite.height / 4)
        Sprites.centerSpriteInSprite(this.top, this.middle)
        this.middle.y = this.top.y + this.top.height + Scale.y(0.01)
        Sprites.centerSpriteInSprite(this.middle, this.bottom)
        this.bottom.y = this.middle.y + this.middle.height + Scale.y(0.01)
    }

    private get title(): Phaser.Text {
        const title = PhaserText.create(this.game, MakeAVideoStore.instance.title || "title", {
            wordWrapWidth: MakeVideoLayoutTypeContainer.wordWrapWidth,
            type: FontType.PLAY,
            align: Align.CENTER,
            fontPx: this.fontPx,
            weight: "bold"
        })
        title.lineSpacing = MakeVideoLayoutTypeContainer.lineSpacing
        return title
    }

    private get username(): Phaser.Text {
        return PhaserText.create(this.game, CCUtils.debug && !PhaserUtils.loggedIn() ? "screenname" : StudentStoreSA.instance.student.screenname, {
            fontPx: this.fontPx,
            weight: "bold",
            type: FontType.PLAY
        })
    }

    private get byline(): Phaser.Text {
        let byline: string
        switch (this.layout) {
            case MakeVideoLayoutTypes.LAYOUT_1:
                byline = "presented by"
                break
            case MakeVideoLayoutTypes.LAYOUT_2:
                byline = "presents"
                break
            case MakeVideoLayoutTypes.LAYOUT_3:
                byline = "a video by"
                break
            default:
                log.error(`Layout not implemented. ${this.layout}`)
        }
        return PhaserText.create(this.game, byline, {
            fontPx: this.fontPx,
            type: FontType.PLAY
        })
    }
}
